// 巡检平台接口——跨域
import request, { IWorkspaceResponse } from './http/Xrequest '

// 算法规则
export const algCode = async function (): Promise<IWorkspaceResponse<any>> {
  const url = '/rule-config/rule-list'
  const result = await request.get(url)
  return result.data
}

// 通过字典类型编码查询字典数据树形结构
export const getDictList = async function (dictType): Promise<IWorkspaceResponse<any>> {
  const url = `/system/dict/data/dict-sub-tree-by-code/${dictType}`
  const result = await request.get(url)
  return result.data
}

// 设置设备算法
export interface setDeviceAlgorithmParam {
  video_id: string,
  algorithm_codes: [],
  device_sn: string
}

export const setDeviceAlg = async function (body: any): Promise<IWorkspaceResponse<any>> {
  const url = '/device/set-device-algorithm'
  const result = await request.post(url, body)
  return result.data
}

// 根据入参获取模板列表
export const getTemplatesList = async function (body:{}): Promise<IWorkspaceResponse<any>> {
  const url = '/report-templates/list-param'
  const result = await request.post(url, body)
  return result.data
}

// 查询模板分类树
export const getTemplatesTree = async function (body:{}): Promise<IWorkspaceResponse<any>> {
  const url = '/report-templates/category/tree'
  const result = await request.post(url, body)
  return result.data
}

// 生成HTML
export const getGenerateHTML = async function (body: any): Promise<IWorkspaceResponse<any>> {
  const url = '/report-templates/generate-html'
  const result = await request.post(url, body)
  return result.data
}

// 导出PDF报表
export const getExportPDFReport = async function (body: any) {
  const url = '/report-templates/export-pdf'
  const result = await request.post(url, body, { responseType: 'blob' })
  return result
}

// 巡检字典接口——获取字典数据列表
export const getDictDataList = async function (dictType: string): Promise<IWorkspaceResponse<any>> {
  const url = `/system/dict/data/type/${dictType}`
  const result = await request.get(url)
  return result.data
}

// 内容管理——app动态链接
export const getContentList = async function (body: any): Promise<IWorkspaceResponse<any>> {
  const url = '/business/content/list'
  const result = await request.post(url, body)
  return result.data
}

export const getServiceBusinessContentList = async (params:any) => {
  const result = await request.post('/business/content/list', params, { customToken: true })
  return result.data
}

// 内容管理——无token
export const getContentNoTokenList = async function (body: any): Promise<IWorkspaceResponse<any>> {
  const url = '/business/content/list-with-no-token'
  const result = await request.post(url, body)
  return result.data
}

// 分页查询空气传感警告列表

export interface SensorQueryParam {
    startTime: string
    endTime: string
    sn: string
}

export interface SensorPageRequest {
    page: number
    page_size: number
    param: SensorQueryParam
}

export const getSensorPage = async function (body: SensorPageRequest): Promise<IWorkspaceResponse<any>> {
  const url = '/business/airsense-warning/page'
  const result = await request.post(url, body)
  return result.data
}

export const getCrawlerGetAll = async () => {
  const url = '/flightRegion/crawler/getAll'
  const result = await request.get(url)
  return result.data
}

export const getAllAIList = async function (): Promise<IWorkspaceResponse<any>> {
  const url = '/business/algorithm/listAll'
  const result = await request.get(url)
  return result.data
}

// 媒体文件分析
export const getMediaFileAnalysis = async function (file_id): Promise<IWorkspaceResponse<any>> {
  const url = `files/file/analysis/${file_id}`
  const result = await request.get(url)
  return result.data
}

// 媒体文件分析统计
export const getMediaFileAnalysisStatistics = async function (folder_id): Promise<IWorkspaceResponse<any>> {
  const url = `/files/file/analysis-count/${folder_id}`
  const result = await request.get(url)
  return result.data
}

// 导出日报PDF报表
export const getDailyData = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/report-templates/export-pdf-daily'
  const result = await request.post(url, body)
  return result.data
}

// 生成3维模型
export const generateThreeDimModel = async function (body: any): Promise<IWorkspaceResponse<any>> {
  const url = '/api/odm/generate3d'
  const result = await request.post(url, body)
  return result.data
}

// 生成面状航线点
export const getWaylinePlan = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline-plan/plan'
  const result = await request.post(url, body)
  return result.data
}

/** 规划带状航线 */
export const getWaylineStrip = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline-plan/strip-plan1'
  const result = await request.post(url, body)
  return result.data
}

// 获取最新云模型版本信息
export const getNewCloudModel = async function (): Promise<IWorkspaceResponse<any>> {
  const url = '/api/odm/get-newest-by-user'
  const result = await request.get(url)
  return result.data
}

/** 获取算法列表 */
export const getAlgorithmList = async function ():Promise<IWorkspaceResponse<any>> {
  const url = '/business/algorithm/listAll'
  const result = await request.get(url)
  return result.data
}

/** 分享直播流 */
export const getShareFlvUrlCode = async function (body: any): Promise<IWorkspaceResponse<any>> {
  const url = '/business/uav/live-stream/share-live'
  const result = await request.post(url, body)
  return result.data
}

/** 根据code获取直播流 */
export const getShareFlvUrl = async function (params: any): Promise<IWorkspaceResponse<any>> {
  const url = `/business/uav/live-stream/get-live-by-code/${params.code}`
  const result = await request.get(url, { params: { password: params.password } })
  return result.data
}

/** 根据入参查询规则 */
export const getRuleGetOneByParam = async function (body: any): Promise<IWorkspaceResponse<any>> {
  const url = '/business/rule/get-one-by-param'
  const result = await request.post(url, body)
  return result.data
}

/** 执行规则并获取告警等级 */
export const getRuleExecuteParam = async function (body: any): Promise<IWorkspaceResponse<any>> {
  const url = '/business/rule/execute'
  const result = await request.post(url, body)
  return result.data
}

/**
 * 根据分片ID获取所有分片的URL列表
 * @param {String} tileId 分片ID
 * @param {String} path 存储路径
 * @param {Number} tilesX 横向分片数量
 * @param {Number} tilesY 纵向分片数量
 * @returns {Promise}
 */
export async function getTileUrls (tileId: string, path: string, tilesX: number, tilesY: number) {
  const url = '/minio-file/get-tile-urls'
  const result = await request.get(url, { params: { tileId, path, tilesX, tilesY } })
  return result.data
}

/** 获取区域 GeoJSON 列表 */
export async function getGeoJsons (data = {}) {
  const url = '/map-geo-json/list'
  const result = await request.post(url, data)
  return result.data
}
